export const VAT_STATUS = {
  PENDING: "pending_vat_check",
  FAILED: "failed_vat_check",
  ACTIVE: "active",
};
